import { ShowScenario } from "components/scenarios/show";
import ScenarioCopy from "components/scenarios/show/scenario/copy";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import React from "react";
import { config, initialState } from "./formConfig";

class CustomShow extends ShowScenario {
    createCopy = () => {
        const { scenario } = this.state.data;
        const { modal } = this.props;
        return modal({
            name: "default",
            title: "Создание копии опроса в рейсе",
            windowMod: "wide",
            CustomBody: ScenarioCopy,
            bodyData: {
                scenario,
                action: this.props.source.copy,
                goToCopy: (id) => this.props.history.push(paths.tripScenariosShow(id)),
            },
        });
    };
}

const ConfiguredShow = (props) => <CustomShow {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "trip-scenarios");
